import styled from 'styled-components';
import { WRAPPER } from '@/shared/styles/themes';
import Logo from '@/shared/assets/logo.svg';
import { Image } from '@/shared/ui/image';

export const StyledFooter = styled.footer`
  display: flex;
  flex-direction: column;
  gap: 24px;
  //align-items: center;
  padding: 24px 0;
  ${WRAPPER}
`;

export const Wrapper = styled.div`
  /* background-image: url('/images/background/footer-background.svg');
              background-repeat: no-repeat;
              background-position: center top;
              background-size: cover; */
`;
export const SmallLayout = styled.div`
  display: none;
  @media screen and (max-width: 640px) {
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 24px;
    align-items: center;
  }
`;
export const MiddleLayout = styled.div`
  display: none;
  @media screen and (max-width: 840px) and (min-width: 641px) {
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 24px;
    align-items: center;
  }
`;
export const TextBlock = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  overflow: hidden;

  border-radius: 8px;
  background-color: #27262b;

  transition: background 0.3s ease;
  &:has(button:hover) {
    background-color: #3c393d;
  }

  ${({ $textExpanded }) =>
    !$textExpanded &&
    `
    max-height: 100px;
    @media (max-width: 768px) {
      max-height: 120px;
  `}
`;
export const TextBlockExpandButton = styled.button`
  display: flex;
  position: absolute;
  align-items: flex-start;
  top: 20px;
  left: 20px;
  width: calc(100% - 40px);
  height: 40px;
  justify-content: flex-end;
  margin-left: auto;
  cursor: pointer;

  @media (max-width: 768px) {
    left: unset;
    right: 20px;
    width: 40px;
  }
`;
export const ExpandIndicator = styled(Image)<{ $expanded?: boolean }>`
  transition: all 0.2s ease;
  display: flex;
  transform-origin: center;
  transform: ${(props) => (props.$expanded ? 'scaleY(1)' : 'scaleY(-1)')};
  will-change: transform;
  backface-visibility: hidden;
`;
export const MiddleSubLayout = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr 180px;
  gap: 18px;
`;
export const LargeLayout = styled.div`
  display: none;
  @media screen and (max-width: 1280px) and (min-width: 841px) {
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 24px;
    align-items: center;
  }
`;
export const LargeSubLayout = styled.div`
  display: grid;
  grid-template-columns: repeat(3, auto);
  width: 100%;
  gap: 36px;
`;
export const ExtraLargeLayout = styled.div`
  display: none;
  @media screen and (min-width: 1281px) {
    display: grid;
    width: 100%;
    grid-template-columns: repeat(4, auto);
    gap: 40px;
    gap: 10px;
  }
`;
export const LayoutBefore640 = styled.div`
  display: none;
  @media screen and (max-width: 640px) {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100%;
  }
`;
export const LayoutAfter640 = styled.div`
  display: none;
  @media screen and (min-width: 641px) {
    display: flex;
    flex: 0 0 150px;
    align-items: flex-end;
  }
`;
export const LayoutBefore1280 = styled.div`
  display: none;
  @media screen and (max-width: 1280px) {
    display: flex;
    flex-direction: column;
    gap: 24px;
    align-items: center;
    width: 100%;
  }
`;
export const LayoutAfter1280 = styled.div`
  display: none;
  @media screen and (min-width: 1281px) {
    display: grid;
    width: 100%;
    grid-template-columns: repeat(4, auto);
    justify-content: space-between;
    align-items: flex-end;
  }
`;

export const LogoStyled = styled(Logo).attrs({
  viewBox: '0 0 180 45',
  preserveAspectRatio: 'xMidYMid meet',
})`
  height: 27px;
  width: 100%;

  @media screen and (min-width: 840px) {
    height: 45px;
  }
`;
export const Line = styled.div<{ $hideOnMobile?: boolean }>`
  display: flex;
  flex: 1 0 0;
  height: 1px;
  background-color: #565656;

  ${(props) =>
    props.$hideOnMobile &&
    `
      display: none;
      @media screen and (min-width: 481px) and (max-width: 840px) {
        display: flex;
        flex: 1 0 0;
        height: 1px;
        background-color: #565656;
      }
  `}
`;
export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  align-self: stretch;
`;
